import { addCrmModalSimplifiedContext } from ".";

export const AddCrmModalSimplifiedContextProvider = addCrmModalSimplifiedContext.Provider;